import React, { SyntheticEvent } from 'react';

import { selectDeliveryOption } from '@r1-frontend/service-engineer-visit/actions';
import DeliveryOptions from '@r1-frontend/service-engineer-visit/components/DeliveryOptions';
import { useContextDispatch, useContextSelector } from '@r1-frontend/service-engineer-visit/hooks';
import getDeliveryOptions from '@r1-frontend/service-engineer-visit/selectors/getDeliveryOptions';
import getLoadingState from '@r1-frontend/service-engineer-visit/selectors/getLoadingState';
import { TDeliveryOption } from '@r1-frontend/service-engineer-visit/types/TDeliveryOption';

type TDeliveryOptionsContainerProps = {
    domain: string,
    onDeliveryOptionSelected?: (deliveryOption: TDeliveryOption) => void,
    sendAnalytics: ({ action, label }: { action: string, label?: string }) => void,
    gaLabel?: string,
    productId?: number,
}

const DeliveryOptionsContainer = ({ domain, onDeliveryOptionSelected, sendAnalytics, productId, gaLabel }: TDeliveryOptionsContainerProps) => {
    const { delivery, loading } = useContextSelector(state => ({
        delivery: getDeliveryOptions(state),
        loading: getLoadingState(state),
    }));
    const dispatch = useContextDispatch();

    const handleDeliveryOptionSelection = (option: TDeliveryOption) => (e: SyntheticEvent) => {
        // the event is calling at the label and the input in Radio Button component, so we should to stop event
        // propagation
        e.preventDefault();
        if (onDeliveryOptionSelected) {
            onDeliveryOptionSelected(option);
        }

        sendAnalytics({
            action: option.name === 'delivery_and_setup' ? 'click_delivery_and_installation' : 'click_only_delivery',
            label: gaLabel || 'start',
        });
        dispatch(selectDeliveryOption(option, domain, productId));
    };


    return (
        <DeliveryOptions
            deliveryOptions={delivery.deliveryOptionsList}
            handleDeliveryOptionSelection={handleDeliveryOptionSelection}
            selectedDeliveryOption={delivery.selectedDeliveryOption}
            loading={loading}
        />
    );
};

export default DeliveryOptionsContainer;
